import * as types from 'misc/types';
import * as actions from 'misc/actions';

const agreement = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_AGREEMENT_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_AGREEMENT_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_AGREEMENT_GET.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_AGREEMENT_PUT.REQUEST:
            return actions.load(state);
        case types.SAGA_AGREEMENT_PUT.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_AGREEMENT_PUT.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default agreement;



// WEBPACK FOOTER //
// ./src/reducers/agreement.js